
import {

  TableRow,
  TableCell,
  
} from "@mui/material";
import {
  charitabletrust,
  companyTasks,
  auditData,
  assignmentData,
  certificationData,
  reraData,
  nbfcData,
  consultationData,
  gstData,
  projectFinancingData,
  femaData,
  accountancyServicesData,
  otherServicesData,
} from "../../caportaldata";

const TrustandCompany = () => {
  return (
    <>     
          {charitabletrust.map((trust, index) => (
            <TableRow key={index}>
              <TableCell
                className={`p-0 ${trust.header ? "bg-primary ps-3" : "ps-3"}`}
              >
                {trust.title}
              </TableCell>
              {[...Array(8)].map((_, i) => (
                <TableCell className="p-0" key={i}></TableCell>
              ))}
            </TableRow>
          ))}

          {companyTasks.map((task, index) => (
            <TableRow key={index}>
              <TableCell
                className={`p-0 ${task.header ? "bg-primary ps-3" : "ps-3"}`}
              >
                {task.title}
              </TableCell>
              {[...Array(8)].map((_, i) => (
                <TableCell className="p-0" key={i}></TableCell>
              ))}
            </TableRow>
          ))}

          {auditData.map((audit, index) => (
            <TableRow key={index}>
              <TableCell
                className={`p-0 ${
                  audit.header
                    ? "bg-primary ps-3"
                    : audit.subHeader
                    ? "bg-danger-subtle ps-3"
                    : "ps-3"
                }`}
              >
                {audit.title}
              </TableCell>
              {[...Array(8)].map((_, i) => (
                <TableCell className="p-0" key={i}></TableCell>
              ))}
            </TableRow>
          ))}
          {assignmentData.map((assignment, index) => (
            <TableRow key={index}>
              <TableCell
                className={`p-0 ${
                  assignment.header
                    ? "bg-primary ps-3"
                    : assignment.subHeader
                    ? "bg-danger-subtle ps-3"
                    : "ps-3"
                }`}
              >
                {assignment.title}
              </TableCell>
              {[...Array(8)].map((_, i) => (
                <TableCell className="p-0" key={i}></TableCell>
              ))}
            </TableRow>
          ))}

          {certificationData.map((task, index) => (
            <TableRow key={index}>
              <TableCell
                className={`p-0 ${task.header ? "bg-primary ps-3" : "ps-3"}`}
              >
                {task.title}
              </TableCell>
              {[...Array(8)].map((_, i) => (
                <TableCell className="p-0" key={i}></TableCell>
              ))}
            </TableRow>
          ))}

          {reraData.map((task, index) => (
            <TableRow key={index}>
              <TableCell
                className={`p-0 ${task.header ? "bg-primary ps-3" : "ps-3"}`}
              >
                {task.title}
              </TableCell>
              {[...Array(8)].map((_, i) => (
                <TableCell className="p-0" key={i}></TableCell>
              ))}
            </TableRow>
          ))}
          {consultationData.map((consultation, index) => (
            <TableRow key={index}>
              <TableCell
                className={`p-0 ${
                  consultation.header
                    ? "bg-primary ps-3"
                    : consultation.subHeader
                    ? "bg-danger-subtle ps-3"
                    : "ps-3"
                }`}
              >
                {consultation.title}
              </TableCell>
              {[...Array(8)].map((_, i) => (
                <TableCell className="p-0" key={i}></TableCell>
              ))}
            </TableRow>
          ))}

          {nbfcData.map((nbfc, index) => (
            <TableRow key={index}>
              <TableCell
                className={`p-0 ${nbfc.header ? "bg-primary ps-3" : "ps-3"}`}
              >
                {nbfc.title}
              </TableCell>
              {[...Array(8)].map((_, i) => (
                <TableCell className="p-0" key={i}></TableCell>
              ))}
            </TableRow>
          ))}

          {gstData.map((gst, index) => (
            <TableRow key={index}>
              <TableCell
                className={`p-0 ${gst.header ? "bg-primary ps-3" : "ps-3"}`}
              >
                {gst.title}
              </TableCell>
              {[...Array(8)].map((_, i) => (
                <TableCell className="p-0" key={i}></TableCell>
              ))}
            </TableRow>
          ))}

          {femaData.map((fema, index) => (
            <TableRow key={index}>
              <TableCell
                className={`p-0 ${fema.header ? "bg-primary ps-3" : "ps-3"}`}
              >
                {fema.title}
              </TableCell>
              {[...Array(8)].map((_, i) => (
                <TableCell className="p-0" key={i}></TableCell>
              ))}
            </TableRow>
          ))}

          {projectFinancingData.map((project, index) => (
            <TableRow key={index}>
              <TableCell
                className={`p-0 ${project.header ? "bg-primary ps-3" : "ps-3"}`}
              >
                {project.title}
              </TableCell>
              {[...Array(8)].map((_, i) => (
                <TableCell className="p-0" key={i}></TableCell>
              ))}
            </TableRow>
          ))}

          {accountancyServicesData.map((accountancy, index) => (
            <TableRow key={index}>
              <TableCell
                className={`p-0 ${
                  accountancy.header ? "bg-primary ps-3" : "ps-3"
                }`}
              >
                {accountancy.title}
              </TableCell>
              {[...Array(8)].map((_, i) => (
                <TableCell className="p-0" key={i}></TableCell>
              ))}
            </TableRow>
          ))}

          {otherServicesData.map((other, index) => (
            <TableRow key={index}>
              <TableCell
                className={`p-0 ${other.header ? "bg-primary ps-3" : "ps-3"}`}
              >
                {other.title}
              </TableCell>
              {[...Array(8)].map((_, i) => (
                <TableCell className="p-0" key={i}></TableCell>
              ))}
            </TableRow>
          ))}
       
    </>
  );
};

export default TrustandCompany;
